import { ThemeProvider } from '@emotion/react';
import NearMeOutlined from '@mui/icons-material/NearMeOutlined';
import NotificationsIcon from '@mui/icons-material/NotificationsNoneOutlined';
import AppBar from '@mui/material/AppBar';
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { createTheme, styled } from '@mui/material/styles';
import { useAppSelector } from 'app/hooks';
import AuthPopup from 'components/organisms/AuthPopup';
import HamburgerMenu from 'components/organisms/Footer/MobileGlobalFooter/HamburgerMenu';
import { NotificationContext } from 'context';
import { selectAuth } from 'features/auth/authSlice';
import * as React from 'react';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderSearchInput from 'components/molecules/InputText/HeaderSearchInput';
import { Link } from 'react-router-dom';
import EarlyAccess from './../../../atoms/EarlyAccess/index';
import { UserInfo } from '@toruslabs/torus-embed';
import { TorusData } from 'interfaces/torus.interface';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#c1c1c1',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const logo = require('assets/logo.png');

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#36899f',
    color: '#36899f',
    '&::after': {
      position: 'relative',
      width: '150%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

const Header = (props: any) => {
  const authState = useAppSelector(selectAuth);

  // const [page, setHomePage] = React.useContext(HomePageContext);

  const history = useNavigate();
  const { setPreviewPage } = useContext(NotificationContext);

  const gotoNotification = (): void => {
    history('/notification');
    setPreviewPage('home');
  };

  const [openSignInModal, setOpenSignInModal] = React.useState<boolean>(false);
  const [torusData, setTorusData] = useState<TorusData | undefined>();
  React.useEffect(() => {
    if (authState.authenticated) {
      setOpenSignInModal(false);
    }
  }, [authState]);

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="relative"
          color="primary"
          sx={{
            top: 0,
            justifyContent: 'center',
            padding: '1.5rem',
            boxShadow: 'none',
            zIndex: 100,
          }}
        >
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ position: 'relative', marginTop: '20px' }}>
              <Link to="/">
                <img
                  src={logo}
                  alt="icon"
                  style={{
                    height: '20px',
                    width: '60px',
                  }}
                />
              </Link>

              <EarlyAccess padding="7px 2px 7px 2px" fontSize="10px" />
            </div>

            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {/* <MobileHomeHeaderSearch /> */}
              <HeaderSearchInput mobile={true} />
            </Grid>
            {/* <Grid item xs={3}></Grid> */}
            {!authState.authenticated ? (
              <Grid
                item
                xs={5}
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  gap: '20px',
                }}
              >
                <HamburgerMenu
                  authenticated={false}
                  handleSignIn={(torusData: TorusData) => {
                    setOpenSignInModal(true);
                    setTorusData(torusData);
                  }}
                >
                  <MenuIcon />
                </HamburgerMenu>
              </Grid>
            ) : (
              <Grid
                item
                xs={5}
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  gap: '20px',
                }}
              >
                {/* <img
                  src={iconback}
                  alt="icon"
                  style={{ width: '25px', minWidth: '25px', height: '25px' }}
                /> */}
                <IconButton
                  size="large"
                  aria-label="show 17 new notifications"
                  color="secondary"
                  sx={{ padding: 'unset' }}
                >
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    variant="dot"
                  >
                    <div onClick={() => gotoNotification()}>
                      <NotificationsIcon sx={{ fontSize: 'normal' }} />
                    </div>
                  </StyledBadge>
                </IconButton>
                <IconButton
                  size="large"
                  aria-label="show 17 new notifications"
                  color="secondary"
                  sx={{ padding: 'unset' }}
                >
                  <div onClick={() => history('/message')}>
                    <NearMeOutlined
                      sx={{ fontSize: 'normal', color: '#ffffff' }}
                    />
                  </div>
                </IconButton>
                <HamburgerMenu
                  handleSignIn={(torusData: UserInfo) => {}}
                  authenticated={true}
                >
                  <MenuIcon />
                </HamburgerMenu>
              </Grid>
            )}
          </Grid>
        </AppBar>

        <AuthPopup
          open={openSignInModal}
          setOpen={setOpenSignInModal}
          torusData={torusData}
        />
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Header;
